module.exports = __webpack_public_path__ + "assets/img/head3-zh.0c780642.png";